import React, { useEffect, useState } from 'react';
import cfac22 from 'js/library/utils/cfac22';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getLastUserInfo, getUrlVariables, trackEventMatomoVisit } from 'js/library/utils/helpers';

// Styles
import { Send } from '@mui/icons-material';
import { Typography, Grid, Input, IconButton, CircularProgress, Tooltip } from '@mui/material';

// Components
import Establishment from 'js/containers/StorePlaces/Establishment';
import GoBack from 'js/containers/GoBack.js';
import LoadingLists from 'js/containers/Loading/LoadingLists';
import Product from 'js/containers/StorePlaces/Product';
import Store from 'js/containers/StorePlaces/Store';

// Apis
import { getCardByIdNode } from 'js/library/utils/API/getCardByIdNode';
import { getEstablishment } from 'js/library/utils/API/getEstablishment';
import { getPostById } from 'js/library/utils/API/apiGetPostById';
import { getProducts } from 'js/library/utils/API/getProducts';
import { getPromotions } from 'js/library/utils/API/getPromotions';

function setStoredList(
  itemId,
  itemInfo,
  objectType,
  latitude,
  longitude,
  from,
  hasMore,
  arrayComplete
) {
  if (!window.storedList) window.storedList = {};

  //gravando p/ salvar o carregamento no retorno do usuário
  window.storedList.itemId = itemId;
  window.storedList.itemInfo = itemInfo;
  window.storedList.objectType = objectType;
  window.storedList.latitude = latitude;
  window.storedList.longitude = longitude;
  window.storedList.from = from;
  window.storedList.hasMore = hasMore;
  window.storedList.arrayComplete = arrayComplete;
  //fim gravação
}

function setObjectType(action) {
  switch (action) {
    case 'promotion_list':
      return 'promotion';
    case 'product_list':
      return 'product';
    case 'establishment_list':
      return 'establishment';
    default:
      return 'promotion';
  }
}

export function StorePlacesLists() {
  const userInfo = getLastUserInfo();
  const getVars = getUrlVariables();
  const location = useLocation();

  const id = getVars.id;

  //verificando se a lista salva no storage é valida
  const validStored =
    window.storedList !== null &&
    window.storedList !== undefined &&
    window.storedList.itemId === id &&
    window.storedList.itemInfo;

  const [itemInfo, setItemInfo] = useState(null);

  const [objectType, setStateObjectType] = useState([]);

  const [arrayComplete, setArrayComplete] = useState(null);
  const [arrayResearch, setArrayResearch] = useState(null);

  const [research, setResearch] = useState('');
  const [researchList, setResearchList] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  //informações de chamada
  const [from, setFrom] = useState(0);
  const size = 12;
  const [hasMore, setHasMore] = useState(true);
  const [tootipIsOpen, setTootipIsOpen] = useState(false);

  const { t } = useTranslation();

  const arrayList = researchList ? arrayResearch : arrayComplete;

  const getCoords = async () => {
    try {
      const pos = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      return {
        long: pos.coords.longitude,
        lat: pos.coords.latitude,
      };
    } catch (error) {
      return { long: '-46.644545', lat: '-23.605190' };
    }
  };

  useEffect(() => {
    async function getPromos() {
      //verificando se a lista já foi carregada e está salva no storage
      if (!validStored && itemInfo === null) {
        const coords = await getCoords();
        const longitude = coords.lat;
        const latitude = coords.long;

        let objectTypeState = [];
        let infoBody = null;

        if (location.state) {
          infoBody = location.state;
          infoBody.query =
            infoBody.query || (infoBody.appFilter && infoBody.appFilter.query) || null;
          if (infoBody.cardId) infoBody.image = infoBody.images.mobileDetails;

          objectTypeState = setObjectType(infoBody.action.type ?? infoBody.action);
        } else {
          let infoBodies = await Promise.allSettled([
            getPostById(userInfo.uId, id),
            getCardByIdNode(id),
          ]);

          if (infoBodies[0].status === 'fulfilled') {
            infoBody = infoBodies[0].value.result;
            infoBody.query = infoBody.appFilter.query;
            objectTypeState = setObjectType(infoBody.action?.type);
          } else {
            infoBody = infoBodies[1].value;
            infoBody.image = infoBody.images.mobileDetails;
            objectTypeState = setObjectType(infoBody.action);
          }
        }
        //setando para futuras consultas
        setStateObjectType(objectTypeState);
        setItemInfo(infoBody);

        const {
          establishmentType,
          geoRadius,
          orderType,
          productType,
          promotionType,
          systemQuery,
          hasVoucher,
          hasPromo,
        } = infoBody?.storePlacesQuery || {};
        const typeSelector = promotionType || productType || establishmentType;

        let payload = {
          hasVoucher: hasVoucher ?? false,
          hasPromo: hasPromo ?? false,
          systemQuery: { ...systemQuery },
          productType: typeSelector,
          orderType: orderType || 'location',
          geoFocus: { lat: latitude.toString(), long: longitude.toString() },
          geoRadius: geoRadius || 10000000,
          plataform: 'web',
          from: from,
          size: size,
        };

        const callback = (apiFunc) => {
          apiFunc(userInfo.uId, payload)
            .then((dataReceived) => {
              setItemsStore(dataReceived, infoBody, objectTypeState);
            })
            .catch((err) => {
              console.log('Error:', err);
              setErrorMessage('Erro ao buscar dados. Tente novamente mais tarde.');
            });
        };

        switch (objectTypeState) {
          case 'promotion':
            !payload.hasVoucher && delete payload.hasVoucher;
            delete payload.hasPromo;
            callback(getPromotions);
            break;
          case 'product':
            delete payload.hasPromo;
            !payload.hasVoucher && delete payload.hasVoucher;
            callback(getProducts);
            break;
          case 'establishment':
            payload.establishmentType = payload.productType;
            delete payload.productType;
            delete payload.hasVoucher;
            callback(getEstablishment);
            break;
          default:
            break;
        }
      } else if (itemInfo === null) {
        setItemInfo(window.storedList.itemInfo);
        setStateObjectType(window.storedList.objectType);
        setArrayComplete(window.storedList.arrayComplete);
        setFrom(window.storedList.from);
        setHasMore(window.storedList.hasMore);
      }
    }

    getPromos();
    // eslint-disable-next-line
  }, []);

  function setItemsStore(dataReceived, infoBody, objectTypeState) {
    setStoredList(
      id,
      infoBody,
      objectTypeState,
      null,
      null,
      size + 1,
      dataReceived.length >= size,
      dataReceived
    );
    setArrayComplete(dataReceived);
    setFrom(size);
    setHasMore(dataReceived.length >= size);
  }

  function setItemsFetchMoreData(dataReceived) {
    const newList = arrayComplete.concat(dataReceived ?? []);
    window.storedList.arrayComplete = newList;
    window.storedList.from = from + size;
    window.storedList.hasMore = dataReceived.length >= size;
    setArrayComplete(newList);
    setFrom(from + size);
    setHasMore(dataReceived.length >= size);
  }

  useEffect(() => {
    //iniciar a página do topo
    window.scrollTo(0, 0);

    document.title = 'Lista de promocao';

    trackEventMatomoVisit('ListaDePromocoes');
  }, []);

  const handleChange = () => (event) => {
    setResearch(event.target.value);

    if (event.target.value.length === 0 && researchList) {
      setResearchList(false);
      setArrayResearch(null);
    }
  };

  const fetchMoreData = async () => {
    const coords = await getCoords();
    const latitude = coords.lat;
    const longitude = coords.long;

    const {
      establishmentType,
      geoRadius,
      orderType,
      productType,
      promotionType,
      systemQuery,
      hasVoucher,
      hasPromo,
    } = itemInfo?.storePlacesQuery || {};
    const typeSelector = promotionType || productType || establishmentType;

    let payload = {
      hasVoucher: hasVoucher ?? false,
      hasPromo: hasPromo ?? false,
      systemQuery: { ...systemQuery },
      productType: typeSelector,
      orderType: orderType || 'location',
      geoFocus: { lat: latitude?.toString(), long: longitude?.toString() },
      geoRadius: geoRadius || 10000000,
      plataform: 'web',
      from: from,
      size: size,
    };

    const callback = (apiFunc) => {
      apiFunc(userInfo.uId, payload)
        .then((dataReceived) => {
          setItemsFetchMoreData(dataReceived);
        })
        .catch((err) => {
          console.log('Erro ao carregar mais dados:', err);
          setHasMore(false);
        });
    };

    switch (objectType) {
      case 'promotion':
        !payload.hasVoucher && delete payload.hasVoucher;
        delete payload.hasPromo;
        callback(getPromotions);
        break;
      case 'product':
        !payload.hasVoucher && delete payload.hasVoucher;
        delete payload.hasPromo;
        callback(getProducts);
        break;
      case 'establishment':
        payload.establishmentType = payload.productType;
        delete payload.productType;
        delete payload.hasVoucher;
        callback(getEstablishment);
        break;
      default:
        break;
    }
  };

  const researchData = async (e) => {
    e.preventDefault();
    setResearchList(true);

    try {
      const coords = await getCoords();
      const latitude = coords.lat;
      const longitude = coords.long;

      const {
        establishmentType,
        geoRadius,
        orderType,
        productType,
        promotionType,
        systemQuery,
        hasVoucher,
        hasPromo,
      } = itemInfo?.storePlacesQuery || {};
      const typeSelector = promotionType || productType || establishmentType;

      let payload = {
        hasVoucher: hasVoucher ?? false,
        hasPromo: hasPromo ?? false,
        systemQuery: { ...systemQuery },
        productType: typeSelector,
        orderType: orderType || 'location',
        geoFocus: { lat: latitude.toString(), long: longitude.toString() },
        geoRadius: geoRadius * 1000 || 10000000,
        plataform: 'web',
        from: 0,
        size: size,
        userQuery: research,
      };

      let result;

      switch (objectType) {
        case 'promotion':
          !payload.hasVoucher && delete payload.hasVoucher;
          delete payload.hasPromo;
          result = await getPromotions(userInfo.uId, payload);
          break;
        case 'product':
          !payload.hasVoucher && delete payload.hasVoucher;
          delete payload.hasPromo;
          result = await getProducts(userInfo.uId, payload);
          break;
        case 'establishment':
          payload.establishmentType = payload.productType;
          delete payload.productType;
          delete payload.hasVoucher;
          result = await getEstablishment(userInfo.uId, payload);
          break;
        default:
          result = [];
          break;
      }

      setArrayResearch(result);
    } catch (error) {
      console.error('Erro ao pesquisar:', error);
      setArrayResearch([]);
    }
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      {itemInfo === null ? (
        <div style={{ textAlign: 'center' }} className="loading-content">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <GoBack location="ListaDePromocao" />
          <img
            src={cfac22('STORAGE_URL') + encodeURIComponent(itemInfo.image) + '?alt=media'}
            alt="thubmnail"
            width="100%"
          />
          <Typography style={{ fontWeight: 'bolder', color: 'black' }} variant="h6" gutterBottom>
            {itemInfo.title}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{
              whiteSpace: 'break-spaces',
              margin: '0.5rem',
            }}
          >
            {itemInfo.description}
          </Typography>
          <Typography color="secondary" variant="subtitle1" style={{ whiteSpace: 'break-spaces' }}>
            {itemInfo.message}
          </Typography>
          <Tooltip arrow open={tootipIsOpen} title={t('errors.mandatory_three')}>
            <div className="search-bar">
              <Grid container spacing={0}>
                <Grid size={{ xs: false, sm: 2, md: 3 }}></Grid>

                <Grid size={{ xs: 12, sm: 8, md: 6 }}>
                  <form
                    onSubmit={(e) => {
                      if (research.length > 2) {
                        setTootipIsOpen(false);
                        researchData(e);
                      } else {
                        e.preventDefault();
                        setTootipIsOpen(true);
                        setTimeout(() => {
                          setTootipIsOpen(false);
                        }, 2000);
                      }
                    }}
                  >
                    <Input
                      placeholder={t('general.search_here')}
                      id="search"
                      fullWidth
                      value={research}
                      onChange={handleChange()}
                      endAdornment={
                        <IconButton disabled={research.length === 0} type="submit">
                          {errorMessage ? (
                            <Send />
                          ) : arrayList === null ? (
                            <CircularProgress size={25} />
                          ) : (
                            <Send />
                          )}
                        </IconButton>
                      }
                    />
                  </form>
                </Grid>

                <Grid size={{ xs: false, sm: 2, md: 3 }}></Grid>
              </Grid>
            </div>
          </Tooltip>
          {arrayList === null ? (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress style={{ padding: '150px 20px', boxSizing: 'content-box' }} />
            </div>
          ) : arrayList.length > 0 ? (
            <div>
              <InfiniteScroll
                dataLength={arrayList.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<LoadingLists />}
                style={{ marginTop: '30px' }}
              >
                <Grid container spacing={0}>
                  {arrayList.map((row, i) => {
                    if (!row) return null;
                    if (row.my_join_field === 'establishment') {
                      return <Establishment key={i} data={row} />;
                    } else if (row.type === 'promotion') {
                      return <Store key={i} data={row} />;
                    } else {
                      return <Product key={i} data={row} />;
                    }
                  })}
                </Grid>
              </InfiniteScroll>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '40px',
              }}
            >
              <Typography variant="subtitle1">{t('errors.no_data_found')}</Typography>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function WrappedComponent(props) {
  const location = useLocation();

  return <StorePlacesLists location={location} {...props} />;
}

